module.exports = __webpack_public_path__ + "img/program_icon03.1f2dd31e.png";